import { lazy, Suspense } from 'react';
import If from 'components/If';
import Spin from 'components/Spin';

const DataCollectionModal = lazy(() => import('pages/DataCollectionModal'));

type Props = {
  isOpen: boolean;
  handleNextModalSequence: () => void;
};

function MissingDataCollection({ handleNextModalSequence, isOpen }: Props) {
  const isModalOpen = isOpen;
  const handleModalClose = () => {
    handleNextModalSequence();
  };

  return (
    <If condition={isModalOpen}>
      <Suspense fallback={<Spin fullscreen />}>
        <DataCollectionModal
          isModalOpen
          handleClose={handleModalClose}
          fromLogin
        />
      </Suspense>
    </If>
  );
}

export default MissingDataCollection;
